import { render } from "./ExamInfoTab.vue?vue&type=template&id=590abeba&scoped=true"
import script from "./ExamInfoTab.vue?vue&type=script&lang=js"
export * from "./ExamInfoTab.vue?vue&type=script&lang=js"

import "./ExamInfoTab.vue?vue&type=style&index=0&id=590abeba&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590abeba"]])

export default __exports__